<template>
  <div class="search-result-container">
    <div class="main">
        <div class="tool-wrap">
            <div class="tabs-box">
                <div
                class="tabs-item"
                v-for="(item, index) in tabs"
                :key="index"
                :class="[item.value == current_tab ? 'active' : '']"
                @click="current_tab = item.value"
                >
                {{ item.name }}
                </div>
            </div>
            <Poptip trigger="hover" placement="bottom-end" width="180px">
                <template #content>
                    <div @click="query.sort='complex'" class="sort-item">Comprehensive Sort <Icon v-if="query.sort == 'complex'" type="md-checkmark"></Icon></div>
                    <div @click="query.sort='time'" class="sort-item">Time Sort <Icon v-if="query.sort == 'time'" type="md-checkmark"></Icon></div>
                </template>
                <div class="sort-box">
                    {{ query.sort == 'complex' ? 'Comprehensive Sort' :'Time Sort' }}<Icon type="md-arrow-dropdown"></Icon>
                </div>
            </Poptip>
        </div>
      <div class="list-box">
        <div
          v-if="['all', 'image', 'video'].includes(current_tab) && infiniteList.length"
          class="masonry-container"
          style="margin-top: 30px; padding-bottom: 70px"
        >
          <masonry
            :cols="{ default: 6, 1700: 5, 1600: 5, 1500: 5, 1400: 4, 1300: 4 }"
            :gutter="{
              default: '30px',
              1700: '20px',
              1600: '20px',
              1500: '20px',
              1400: '20px',
              1300: '20px',
            }"
          >
            <div
              v-for="(item, index) in infiniteList"
              :key="index"
              @click="onArticleDetail(item)"
            >
              <template>
                <div class="masonry-item">
                  <img
                    v-if="item.type == 2"
                    src="../../assets/images/icon-play.png"
                    style="
                      width: 30px;
                      height: 30px;
                      position: absolute;
                      top: 10px;
                      right: 10px;
                      z-index: 10;
                    "
                    alt=""
                  />
                  <div class="image-container">
                    <img
                      :src="item.cover"
                      @load="onImageLoad"
                      class="masonry-image"
                    />
                  </div>
                  <div class="item-content">
                    <div class="title">{{ item.title }}</div>
                    <div class="bottom-box">
                      <div class="nick-avatar">
                        <img
                          class="avatar"
                          :src="item.member.avatar | default_img"
                        />
                        <div class="nick">
                          {{ item.member.nickname || item.member.username }}
                        </div>
                      </div>
                      <div class="like-box">
                        <img
                          src="../../assets/images/icon-like.png"
                          style="width: 16px; height: 16px"
                        />
                        <div style="margin-left: 3px">
                          {{ item.collect_count || 0 }}
                        </div>
                      </div>
                    </div>
                    <!-- <p>{{ item.description }}</p> -->
                  </div>
                </div>
              </template>
            </div>
          </masonry>
        </div>
        <div class="design-list" v-else-if="current_tab === 'design' && infiniteList.length">
          <div class="list-item" v-for="(item,index) in infiniteList" :key="index" @click="$router.push({name:'ProductDetail',query:{uuid:item.uuid}})">
            <img :src="item.cover | default_img" alt="" />
            <div class="content-box">
              <div class="title">{{item.name}}</div>
              <div class="cate">{{item.product_category_name}}</div>
              <div class="desc">
                {{ item.description }}
              </div>
              <div class="time">{{item.create_time}}</div>
            </div>
          </div>
        </div>
        <div class="user-list" v-else-if="current_tab === 'user' && infiniteList.length">
          <div class="follow-box">
            <div
              class="list-item"
              v-for="(item, index) in infiniteList"
              :key="`follow-${index}`"
            >
              <img
                @click="
                  $router.push({
                    name: 'UserProfile',
                    params: { code: item.code },
                  })
                "
                :src="item.avatar | default_img"
              />
              <div class="nickname">{{ item.nickname || item.username }}</div>
              <div class="job-city">
                {{ item.job }} <span v-if="item.job && item.city">|</span>
                {{ item.city || "Earth" }}
              </div>
              <div class="user-data">
                <div class="item">
                  <div class="num">{{ item.create_num }}</div>
                  <div class="item-title">Notes</div>
                </div>
                <div class="item">
                  <div class="num">{{ item.design_num }}</div>
                  <div class="item-title">Design Creation</div>
                </div>
                <div class="item">
                  <div class="num">{{ item.fans_num }}</div>
                  <div class="item-title">Followers</div>
                </div>
              </div>
              <div class="btn-follow" v-if="!item.need_follow">
                <div class="btn-text">Following</div>
                <Poptip placement="bottom" trigger="hover">
                  <template #content>
                    <div class="btn-menu">
                      <div
                        class="menu-item"
                        @click="onFollowUser(item.id, index)"
                      >
                        <div class="btn-text">Unfollow</div>
                        <img src="../../assets/images/icon-list-cancel.png" />
                      </div>
                    </div>
                  </template>
                  <div class="btn-icon"></div>
                </Poptip>
              </div>
              <div
                class="btn-unfollow"
                v-else
                @click="onFollowUser(item.id, index)"
              >
                Follow
              </div>
            </div>
          </div>
        </div>
        <div class="empty-container" v-else>
            <div class="empty-icon"></div>
            <div class="result-text">No relevant information found</div>
            <div class="result-tips">Try another keyword~</div>
        </div>
      </div>
    </div>
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="uuid"
    ></ArticleDetail>
  </div>
</template>

<script>
import infiniteMixin from "@/mixins/infinite";
import ArticleDetail from "@/components/ArticleDetail";
import { SearchResult } from "@/api/index"
import { FollowUser } from "@/api/social";
export default {
  data() {
    return {
      query: {
        keyword: "",
        sort:'complex'
      },
      tabs: [
      { name: "All", value: "all" },
        { name: "Images", value: "image" },
        { name: "Videos", value: "video" },
        { name: "Designs", value: "design" },
        { name: "Users", value: "user" },
      ],
      current_tab: "all",
      uuid: "",
      show_detail: false,
    };
  },
  watch:{
    current_tab(news,olds){
        if(news != olds){
            this.getInfiniteList(true);
        }
    },
    '$route'() {
        this.query.keyword = this.$route.params.keyword;
        this.getInfiniteList(true);
    },
    'query.sort'(news,olds){
        if(news != olds){
            this.getInfiniteList(true);
        }
    }
  },
  components: {
    ArticleDetail,
  },
  mixins: [infiniteMixin],
  mounted() {
    const { keyword } = this.$route.params;
    window.addEventListener("scroll", this.handleScroll);
    this.query.keyword = keyword;
    this.getInfiniteList(true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onReachBottom:_.debounce(function(){
      this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;
        console.log('offsetBottom',offsetBottom);
        if (offsetBottom <= 500) {
          if (this.loadingMore || this.infiniteEnded || this.first_loading) return;
          // console.log('触发触底加载...',new Date().getTime());
          this.loadingMore = true;
          this.getInfiniteList().finally(() => {
            this.loadingMore = false;
          });
        }
      });
    },100),
    handleScroll() {
      this.onReachBottom();
    },
    async onFollowUser(id, index) {
      try {
        const {type} = this;
        const need_follow = this.infiniteList[index].need_follow;
        const follow_each = this.infiniteList[index].follow_each;
        if(!need_follow){
            this.$DModal.confirm({
                content: 'Confirm to unfollow?',
                okText:'Confirm',
                cancelText:'Cancel',
                onOK: async () => {
                    await FollowUser({ follow_id: id });
                    this.$set(this.infiniteList[index], "need_follow", !need_follow);
                    this.$layer.msg("Operation successful");
                }
            })
        }else{
            await FollowUser({ follow_id: id });
            this.$set(this.infiniteList[index], "need_follow", !need_follow);
            this.$layer.msg("Operation successful");
        }
      } catch (e) {
        console.log("e", e);
        this.$layer.msg("Operation failed");
      }
    },
    onArticleDetail(data) {
      console.log("data---", data);
      this.uuid = data.uuid;
      this.show_detail = true;
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    onCloseArticleDetail() {
      this.show_detail = false;
    },
    async getInfiniteData(pageIndex, pageSize) {
        const {query,current_tab} = this;
        const { keyword,sort } = query;
        console.log("keyword", keyword);
        const res = {};
        const {data} = await SearchResult({keyword,page:pageIndex,limit:pageSize,type:current_tab,sort});
        res.data = data.length ? data : [];
        return res;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./result.scss";
</style>
